import React from "react";

const MailboxIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 50 50"
            strokeWidth="1.5"
            stroke="currentColor"
            {...props}
        >
            <path d="M 17 10 C 12.042969 10 8 14.042969 8 19 L 8 35 C 8 35.550781 8.449219 36 9 36 L 28 36 L 28 46 L 30 46 L 30 36 L 32 36 L 32 46 L 34 46 L 34 36 L 47 36 C 47.550781 36 48 35.550781 48 35 L 48 19 C 48 14.042969 43.957031 10 39 10 Z M 17 12 C 20.878906 12 24 15.121094 24 19 L 24 34 L 10 34 L 10 19 C 10 15.121094 13.121094 12 17 12 Z M 22.625 12 L 39 12 C 42.878906 12 46 15.121094 46 19 L 46 34 L 26 34 L 26 19 C 26 16.171875 24.675781 13.652344 22.625 12 Z M 32 17 C 30.894531 17 30 17.894531 30 19 C 30 20.105469 30.894531 21 32 21 C 32.738281 21 33.371094 20.597656 33.71875 20 L 39 20 L 39 24 L 43 24 L 43 18 L 33.71875 18 C 33.371094 17.402344 32.738281 17 32 17 Z M 13.71875 20 C 13.167969 20.078125 12.78125 20.589844 12.859375 21.140625 C 12.9375 21.691406 13.449219 22.078125 14 22 L 20 22 C 20.359375 22.003906 20.695313 21.816406 20.878906 21.503906 C 21.058594 21.191406 21.058594 20.808594 20.878906 20.496094 C 20.695313 20.183594 20.359375 19.996094 20 20 L 14 20 C 13.96875 20 13.9375 20 13.90625 20 C 13.875 20 13.84375 20 13.8125 20 C 13.78125 20 13.75 20 13.71875 20 Z" />
        </svg>
    );
};

export default MailboxIcon;
